// JsFromRoutes CacheKey 729b75328e4ad402c34af357a54666f2
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/client'

export default {
  show: /* #__PURE__ */ definePathHelper('get', '/design'),
}
